import { useQuery } from "@tanstack/react-query";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";
import getQueryKeys from "common/datahooks/getQueryKeys";
import { get } from "common/helpers/HTTP";

import type { LeadList } from "../types";

async function getLeadLists(workspaceId: string) {
  return (await get(`workspaces/${workspaceId}/lists`)).lists;
}

export default function useLeadLists() {
  const { id: workspaceId } = useSelectedWorkspaceContext();
  const { listsKeys } = getQueryKeys(workspaceId);

  const {
    isLoading: isLoadingLeadLists,
    data: leadLists,
    error: leadListsError,
    refetch: refetchLeadLists,
  } = useQuery<LeadList[]>({
    queryKey: listsKeys.list,
    queryFn: () => getLeadLists(workspaceId),
  });

  return { leadLists, isLoadingLeadLists, leadListsError, refetchLeadLists };
}
